import { Component, OnInit,Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-folder-select-modal',
  templateUrl: './folder-select-modal.page.html',
  styleUrls: ['./folder-select-modal.page.scss'],
})
export class FolderSelectModalPage implements OnInit {
  @Input() selected_files: any = null;
  @Input() inc_current_folder: any = null;
  @Input() move: any = false;


  data: any = null;
  current_folder: any = {
    guid: '0'
  };
  breadcrumbs: any = [];
  


  constructor(
    private apiService: ApiService, 
    public globalService: GlobalService,
    private modalController: ModalController) { }

  ngOnInit() {
    console.log(this.selected_files);
    if(this.inc_current_folder)
      this.current_folder.guid = this.inc_current_folder.guid;
    else
      this.current_folder.guid = '0';
    this.Get(this.current_folder.guid);
  }


  //Gets the information about the current folder and gets all the first info about the root folder
  async Get(guid) {
    let temp_data: any = await this.apiService.get(`files/${guid}`);
    if (temp_data.success) {
      this.data = temp_data.data;
      this.current_folder = temp_data.parent[0];
      if(this.data) {
        console.log("Before");
        for (let i = 0; i < this.data.length; i++) {
          if(this.data[i].is_file) this.data.splice(i,1);
        }
        console.log("Before");
      }
      
    }
    else this.globalService.presentToastMessage(temp_data.message, temp_data.success);
    if (this.data == null) this.data = [];
    this.breadcrumbs = await this.GenerateBreadCrumbs(this.current_folder);
    
  }
  
  //This needs to generate breadcrumbs based on the page
  async GenerateBreadCrumbs(current_folder) {
    var current_path = '';
    var current_guid = current_folder.guid;
    var breadcrumbs = [];

    console.log(current_folder);
    current_path = current_folder.path;


    while (current_path.includes('/')) {
      let temp_data: any = await this.apiService.get(`folder/parent/${current_guid}`);
      current_path = temp_data.data[0].path;
      current_guid = temp_data.data[0].guid;
      console.log(temp_data);
      if(current_path.includes('/')) breadcrumbs.push({path: current_path, guid: current_guid});
      //+= `<a href="file-explorer#${temp_data.data[0].guid}">${this.globalService.GetPathName(current_path)}</a> `;
    }
    breadcrumbs.unshift({path: '0', guid: '0'});
    //breadcrumbs = `<a href="file-explorer#0">Home</a> ` + breadcrumbs;
    if(this.current_folder.path.includes('/'))
      breadcrumbs.push({path: this.current_folder.path, guid: this.current_folder.guid});
    //breadcrumbs += `<a href="file-explorer#${this.current_folder.guid}">${this.globalService.GetPathName(this.current_folder.path)}</a> `;

    return breadcrumbs;

  }

  async Dismiss() {
    this.modalController.dismiss();
  }

  async SelectFolder() {
    this.modalController.dismiss(this.current_folder);
  }




}
